function NoPage() {
    return (
        <p>This is error page, meaning you either encountered an error, or was just wrongly redirected</p>
    )
}

export default NoPage;